export default "__VITE_ASSET__BAWEJInk__"